import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import { adminMcpServersQueryKey } from "./useAdminMcpServers";

interface UpdateAllowedToolsArgs {
  serverId: string;
  allowedTools: Record<string, boolean> | null;
}

export function useAdminUpdateAllowedTools() {
  const { mcpRegistryService } = useDomainServices();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ serverId, allowedTools }: UpdateAllowedToolsArgs) =>
      mcpRegistryService.adminUpdateAllowedTools(serverId, allowedTools),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: adminMcpServersQueryKey,
      });
    },
  });
}
